import { eventLink } from './eventNav';

// Shared deep-link builders for external systems referenced by opportunity/ticket ids.
export function sfOpportunityUrl(oppId) {
  if (!oppId) return null;
  return `https://fortinet.lightning.force.com/lightning/r/Opportunity/${oppId}/view`;
}

export function smartTicketUrl(ticketId) {
  if (!ticketId) return null;
  return `https://smart.myfortinet.com/view.php?id=${ticketId}`;
}

// In-app deep links. `workshop.id` is the primary key, NOT the `wscode` that several exec
// endpoints label `workshop_id` (gotchas.md).
export function workshopUrl(workshopId) {
  if (workshopId === null || workshopId === undefined || workshopId === '') return null;
  return `/workshops/${encodeURIComponent(workshopId)}`;
}

export function eventUrl(eventId) {
  if (eventId === null || eventId === undefined || eventId === '') return null;
  return eventLink(encodeURIComponent(eventId), 'results', { anchor: 'analytics' });
}

// Plan 2217: the opportunity deep dive (influence snapshot) for one deal.
export function dealUrl(oppId) {
  if (!oppId) return null;
  return `/exec/deal/${encodeURIComponent(oppId)}`;
}
